exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Logo-module__logoContainer--2S56n {\r\n    margin: 28px 0 0 0;\r\n    width: 100%;\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n\r\n/*임시로 영역을 잡아줌*/\r\n.Logo-module__logo--1cR5F {\r\n    width: 240px;\r\n    height: 48px;\r\n    overflow : hidden;\r\n\r\n    background-size: contain;\r\n    background-position: center;\r\n    background-repeat: no-repeat;\r\n}", ""]);

// exports
exports.locals = {
	"logoContainer": "Logo-module__logoContainer--2S56n",
	"logo": "Logo-module__logo--1cR5F"
};